export default __webpack_public_path__ + "static/media/many-helping-hands.1a0174c6.jpg";